import { createAction, props } from '@ngrx/store';
import { AuthState } from './authentication.reducer';

export const login = createAction('[LOGIN_ACTION] User Login', props<AuthState>());
export const logout = createAction('[LOGOUT_ACTION] User Logout');
